import { AxiosResponse } from "axios";
import { GenericService } from "./Generic.service";

export interface CompanyOccupationalHealth {
  id: string;
  nomeFantasia: string;
  inativo: false;
}

export class CompanyService extends GenericService<string> {
  readonly URI: string = "Empresa";

  constructor() {
    super();
    this.setUri(this.URI);
  }

  public async registerCompany(company: any) {
    return await super.post(company);
  }

  public async getUnidadeAtendimento(companyId: number | string) {
    return await super.getByResource<
      AxiosResponse<CompanyOccupationalHealth[]>
    >(`${companyId}/UnidadeAtendimento/Combo`);
  }

  public async editCompany(company: any, companyId: string) {
    return await super.putByResource(company, companyId);
  }

  public async getCompanies() {
    return await super.getByResource("", { PageSize: 500 });
  }

  public async getCompanyById(companyId: string) {
    return await super.getByResource(`${companyId}`);
  }

  public async getCompany(text: string) {
    return await super.getByResource("", { PageSize: 500, text: text });
  }

  public async activateCompany(companyId: string) {
    return await super.patchByResource(companyId, `${companyId}/Activate`);
  }

  public async inactivateCompany(companyId: string) {
    return await super.patchByResource(companyId, `${companyId}/Inactivate`);
  }
  //SAUDE OCUPACIONAL DA EMPRESA

  public async registerSaudeOcupacional(companyId: string, occupHealth: any) {
    return await super.postByResource(
      occupHealth,
      `${companyId}/SaudeOcupacional`
    );
  }

  public async editSaudeOcupacional(
    companyId: string,
    occupHealthId: string,
    occupHealth: any
  ) {
    return await super.putByResource(
      occupHealth,
      `${companyId}/SaudeOcupacional/${occupHealthId}`
    );
  }

  public async getCompanySaudeOcupacional(companyId: string) {
    return await super.getByResource(`${companyId}/SaudeOcupacional`, {
      PageSize: 500,
    });
  }

  public async getCompanySaudeOcupacionalByName(
    text: string,
    companyId: string
  ) {
    return await super.getByResource(`${companyId}/SaudeOcupacional`, {
      PageSize: 500,
      text: text,
    });
  }

  public async activateSaudeOcupacional(
    companyId: string,
    occupHealthId: string
  ) {
    return await super.patchByResource(
      companyId,
      `${companyId}/SaudeOcupacional/${occupHealthId}/Activate`
    );
  }

  public async getPeriodicsByCompanyPerson(companyId: string, personId: string){
    return await super.getByResource(`${companyId}/SaudeOcupacional/Periodico/${personId}`)
  }

  public async inactivateSaudeOcupacional(companyId: string, occupHealthId: string) {
    return await super.patchByResource(companyId, `${companyId}/SaudeOcupacional/${occupHealthId}/Inactivate`)
  }

  public async getUnidsAtendiment(companyId: string) {
    return await super.getByResource(`${companyId}/UnidadeAtendimento/Combo`);
  }

}
